import axios from 'axios';

const getFilterCatsApi = async (langIsoCode) => {
  try {
    const url = '/General/filterCats';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getFilterCatsApi;
